import {baseUrlRes1} from '../constants/baseUrl';
import {apiPost} from '../library/helpers/apiHelper';

const pushNotificationForVideoCall = async data => {
  try {
    const response = await apiPost('api/v1/notification/v2', data);
    return {msg: response.message, status: 'success'};
  } catch (error) {
    return {
      msg: 'Cannot send notification at this moment',
      status: 'error',
    };
  }
};

const triggerCallScreenIos = async data => {
  try {
    const response = await apiPost('api/v1/notification/v4', data);
    return {msg: response.message, status: 'success'};
  } catch (error) {
    return {
      msg: 'Cannot send notification at this moment',
      status: 'error',
    };
  }
};

export const addAlertApi = async data => {
  return await apiPost('api/v1/addAlert', data);
};

export {pushNotificationForVideoCall, triggerCallScreenIos};
